export enum FileMenuOption {
  Download = 'download',
  Statistics = 'open-statistics',
  Pin = 'pin',
  UnPin = 'un-pin',
  Delete = 'delete',
}
